import { processProductList } from "utils/RecommendationsUtils";
import {
  FETCH_BESTSELLERS_PRODUCTS,
  FETCH_FREQUENT_BOUGHT_TOGETHER_PRODUCTS,
  FETCH_PRODUCTS_DETAILS_FOR_FREQ_PRODUCTS,
  FETCH_TRENDING_PRODUCTS,
  FreqBoughtProductData,
  freqBoughtTogetherList,
  GlobalRecommendationList,
  RESET_FREQ_BOUGHT_TOGETHER_PRODUCTS,
  RESET_GLOBAL_RECOMMENDATIONS_LIST,
  FETCH_PRODUCT_IDS_BY_CODES,
  UPDATE_STATE_PRODUCT_DATA,
  UPDATE_PRODUCT_DETAILS_FETCHED,
} from "./RecommendationType";
import {
  REFRESH_PRODUCT,
  CategoryToProductData,
} from "../product-list/ProductListTypes";

export interface RecommendationListState {
  freqBoughtTogetherList: freqBoughtTogetherList[];
  globalRecommendationList: GlobalRecommendationList[];
  freqBoughtTogetherIds: string[];
  bestsellersProductIds: string[];
  trendingProductIds: string[];
  isFetchingFreqProductsIds: boolean;
  isProductDetailsFetched: boolean;
  isFetchingGlobalRecommendations: boolean;
  isGlobalRecommendations: boolean;
  productsListDeatils: FreqBoughtProductData[];
  isFetchingProductIdsByCode: boolean;
  freqBoughtTogetherProductIds: string[];
}

const initialState: RecommendationListState = {
  freqBoughtTogetherList: [],
  freqBoughtTogetherIds: [],
  globalRecommendationList: [],
  trendingProductIds: [],
  bestsellersProductIds: [],
  isFetchingFreqProductsIds: false,
  isProductDetailsFetched: false,
  isFetchingGlobalRecommendations: false,
  isGlobalRecommendations: false,
  productsListDeatils: [],
  isFetchingProductIdsByCode: false,
  freqBoughtTogetherProductIds: [],
};

export const RecommendationProductsListReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case FETCH_FREQUENT_BOUGHT_TOGETHER_PRODUCTS.REQUEST: {
      return {
        ...state,
        isFetchingFreqProductsIds: true,
      };
    }
    case FETCH_FREQUENT_BOUGHT_TOGETHER_PRODUCTS.SUCCESS: {
      const { productCodes, productsData } = processProductList(action.payload);
      return {
        ...state,
        freqBoughtTogetherList: productsData,
        freqBoughtTogetherIds: productCodes,
        isFetchingFreqProductsIds: false,
        isProductDetailsFetched: productCodes.length > 0 ? true : false,
      };
    }
    case FETCH_FREQUENT_BOUGHT_TOGETHER_PRODUCTS.FAILURE: {
      return {
        ...state,
        freqBoughtTogetherList: [],
        isFetchingFreqProductsIds: false,
      };
    }
    case FETCH_PRODUCTS_DETAILS_FOR_FREQ_PRODUCTS.REQUEST: {
      return {
        ...state,
        isProductDetailsFetched: true,
      };
    }
    case FETCH_PRODUCTS_DETAILS_FOR_FREQ_PRODUCTS.SUCCESS: {
      const productsList = action?.payload?.results ?? [];
      const productMap = new Map();

      productsList.forEach((item) => {
        if (item.cachedProduct && item.cachedProduct.product.code) {
          productMap.set(item?.cachedProduct.product.code, {
            ...item?.cachedProduct.product,
            cachedAt: item?.cachedProduct.cachedAt,
            isRefreshing: false,
          });
        }
      });
      const compareProductList = state.isGlobalRecommendations
        ? state.globalRecommendationList
        : state.freqBoughtTogetherList;
      const finalProducts = compareProductList.map(({ productCode }) => {
        if (productMap.has(productCode)) {
          return productMap.get(productCode);
        } else {
          return {
            productId: productCode,
            code: productCode,
            analyticsId: productCode,
            isRefreshing: false,
          };
        }
      });
      return {
        ...state,
        isProductDetailsFetched: false,
        productsListDeatils: finalProducts,
      };
    }
    case FETCH_PRODUCTS_DETAILS_FOR_FREQ_PRODUCTS.FAILURE: {
      return {
        ...state,
        isProductDetailsFetched: false,
        productsListDeatils: [],
      };
    }
    case FETCH_BESTSELLERS_PRODUCTS.REQUEST: {
      return {
        ...state,
        isFetchingGlobalRecommendations: true,
      };
    }
    case FETCH_BESTSELLERS_PRODUCTS.SUCCESS: {
      const { productCodes, productsData } = processProductList(action.payload);
      return {
        ...state,
        isGlobalRecommendations: true,
        globalRecommendationList: productsData,
        bestsellersProductIds: productCodes,
        isFetchingGlobalRecommendations: false,
        isProductDetailsFetched: productCodes.length > 0 ? true : false,
      };
    }
    case FETCH_BESTSELLERS_PRODUCTS.FAILURE: {
      return {
        ...state,
        isGlobalRecommendations: false,
        isFetchingGlobalRecommendations: false,
      };
    }
    case FETCH_TRENDING_PRODUCTS.REQUEST: {
      return {
        ...state,
        isFetchingGlobalRecommendations: true,
      };
    }
    case FETCH_TRENDING_PRODUCTS.SUCCESS: {
      const { productCodes, productsData } = processProductList(action.payload);
      return {
        ...state,
        globalRecommendationList: productsData,
        trendingProductIds: productCodes,
        isFetchingGlobalRecommendations: false,
        isGlobalRecommendations: true,
        isProductDetailsFetched: productCodes.length > 0 ? true : false,
      };
    }
    case FETCH_TRENDING_PRODUCTS.FAILURE: {
      return {
        ...state,
        freqBoughtTogetherList: [],
        isFetchingGlobalRecommendations: false,
        isGlobalRecommendations: false,
      };
    }
    case RESET_FREQ_BOUGHT_TOGETHER_PRODUCTS:
      return {
        ...state,
        isProductDetailsFetched: false,
        isFetchingFreqProductsIds: false,
        freqBoughtTogetherIds: [],
        freqBoughtTogetherList: [],
        productsListDeatils: [],
      };

    case RESET_GLOBAL_RECOMMENDATIONS_LIST:
      return {
        ...state,
        isProductDetailsFetched: false,
        isFetchingGlobalRecommendations: false,
        isGlobalRecommendations: false,
        globalRecommendationList: [],
        productsListDeatils: [],
        trendingProductIds: [],
        bestsellersProductIds: [],
      };
    case FETCH_PRODUCT_IDS_BY_CODES.REQUEST: {
      return {
        ...state,
        isFetchingProductIdsByCode: true,
        freqBoughtTogetherProductIds: [],
      };
    }
    case FETCH_PRODUCT_IDS_BY_CODES.SUCCESS: {
      return {
        ...state,
        isFetchingProductIdsByCode: false,
        freqBoughtTogetherProductIds: action.payload.productCodes || [],
      };
    }
    case FETCH_PRODUCT_IDS_BY_CODES.FAILURE: {
      return {
        ...state,
        isFetchingProductIdsByCode: false,
        productCodeMappings: [],
      };
    }
    case UPDATE_STATE_PRODUCT_DATA: {
      const { products, recommendationType } = action.payload;
      const { productCodes, productsData } = processProductList(products);
      const isGlobalRecommendations = state.isGlobalRecommendations;
      return {
        ...state,
        globalRecommendationList: isGlobalRecommendations
          ? productsData
          : state.globalRecommendationList,
        freqBoughtTogetherList: isGlobalRecommendations
          ? state.freqBoughtTogetherList
          : productsData,
        [recommendationType]: productCodes,
      };
    }
    case UPDATE_PRODUCT_DETAILS_FETCHED: {
      const productList = state.isGlobalRecommendations
        ? state.globalRecommendationList
        : state.freqBoughtTogetherList;
      const finalProducts = productList.map(({ productCode }) => {
        return {
          productId: productCode,
          code: productCode,
          analyticsId: productCode,
        };
      });
      return {
        ...state,
        isProductDetailsFetched: false,
        productsListDeatils: finalProducts,
      };
    }
    case REFRESH_PRODUCT.REQUEST: {
      const { productId } = action.payload;
      return {
        ...state,
        productsListDeatils: state.productsListDeatils.map((product) =>
          product.productId === productId
            ? { ...product, isRefreshing: true }
            : product,
        ),
      };
    }
    case REFRESH_PRODUCT.SUCCESS: {
      const responseData = action.payload as CategoryToProductData;
      return {
        ...state,
        productsListDeatils: state.productsListDeatils.map((product) =>
          product.productId === responseData.productId
            ? {
                ...product,
                cachedAt: responseData.cachedProduct.cachedAt,
                isRefreshing: false,
                code: responseData.cachedProduct?.product?.code,
                name: responseData.cachedProduct?.product?.name,
                thumbnail: responseData.cachedProduct?.product?.thumbnail,
                isPublished: responseData.cachedProduct?.product?.isPublished,
                stock: responseData.cachedProduct?.product?.stock,
                listPrice: responseData.cachedProduct?.product?.listPrice,
                lowPrice: responseData.cachedProduct?.product?.lowPrice,
                highPrice: responseData.cachedProduct?.product?.highPrice,
                stockValue: responseData.cachedProduct?.product?.stockValue,
                colors: responseData.cachedProduct?.product?.colors,
                imageGroups: responseData.cachedProduct?.product?.imageGroups,
                categorySpecific:
                  responseData.cachedProduct?.product?.categorySpecific,
              }
            : product,
        ),
      };
    }
    case REFRESH_PRODUCT.FAILURE: {
      const { productId } = action.payload;
      return {
        ...state,
        productsListDeatils: state.productsListDeatils.map((product) =>
          product.productId === productId
            ? { ...product, isRefreshing: false }
            : product,
        ),
      };
    }
    default:
      return state;
  }
};
